/* ASPY · MINIASPIRADOR 2 EN 1 — funciones propias (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function una(el, nombre) {
    if (el.dataset[nombre]) return false;
    el.dataset[nombre] = '1';
    return true;
  }

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var p = v.split('.');
    var coma = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + p[1];
    var punto = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + p[1];
    return (format || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, p[0])
      .replace(/\{\{\s*amount\s*\}\}/, punto);
  }

  // Apariciones al hacer scroll
  function initAparece(root) {
    var els = (root || document).querySelectorAll('.as-aparece:not(.is-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  // Portada: la foto del hero se desplaza suave al hacer scroll (parallax)
  function initHero(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-as-hero]').forEach(function (sec) {
      if (!una(sec, 'asIni')) return;
      var img = sec.querySelector('.as-hero__fondo img');
      var fuerza = parseFloat(sec.dataset.parallax || '0') / 100;
      if (!img || !fuerza || window.innerWidth < 990) return;
      var pendiente = false;
      function mover() {
        pendiente = false;
        var r = sec.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-r.top * fuerza).toFixed(1) + 'px,0)';
      }
      window.addEventListener('scroll', function () { if (!pendiente) { pendiente = true; requestAnimationFrame(mover); } }, { passive: true });
      mover();
    });
  }

  // Portada: la cabecera va transparente encima de la foto y se oscurece al bajar
  function initCabecera() {
    if (!document.body.classList.contains('as-cab-transparente')) return;
    var cab = document.querySelector('.section-header');
    if (!cab) return;
    function medir() { document.documentElement.style.setProperty('--as-cab-h', cab.offsetHeight + 'px'); }
    function solida() { document.body.classList.toggle('as-cab-solida', window.scrollY > 40); }
    medir();
    solida();
    window.addEventListener('resize', medir);
    window.addEventListener('scroll', solida, { passive: true });
  }

  // Oferta: cuenta atrás hasta la fecha de fin; al llegar a cero se oculta el aviso
  function initOferta(root) {
    (root || document).querySelectorAll('[data-as-oferta]').forEach(function (el) {
      if (!una(el, 'asIni')) return;
      var fin = Date.parse(el.dataset.asOferta);
      if (isNaN(fin)) return;
      var dos = function (n) { return (n < 10 ? '0' : '') + n; };
      var partes = { d: el.querySelector('[data-as-d]'), h: el.querySelector('[data-as-h]'), m: el.querySelector('[data-as-m]'), s: el.querySelector('[data-as-s]') };
      function pintar() {
        var q = Math.floor((fin - Date.now()) / 1000);
        if (q <= 0) { el.hidden = true; clearInterval(t); return; }
        partes.d.textContent = Math.floor(q / 86400);
        partes.h.textContent = dos(Math.floor(q % 86400 / 3600));
        partes.m.textContent = dos(Math.floor(q % 3600 / 60));
        partes.s.textContent = dos(q % 60);
      }
      var t = setInterval(pintar, 1000);
      pintar();
    });
  }

  // Etiqueta y aviso junto al precio: se ocultan al acabar la oferta (aunque la página esté en caché)
  function initOfertaPrecio(root) {
    (root || document).querySelectorAll('[data-as-oferta-fin]').forEach(function (el) {
      var fin = Date.parse(el.dataset.asOfertaFin);
      if (!isNaN(fin) && Date.now() >= fin) el.hidden = true;
    });
    var b = document.body;
    if (!root && b.dataset.asOfertaFinBody && Date.now() >= Date.parse(b.dataset.asOfertaFinBody)) b.classList.remove('as-oferta-on');
  }

  // Opiniones: flechas del carril deslizable
  function initResenas(root) {
    (root || document).querySelectorAll('[data-as-resenas]').forEach(function (sec) {
      if (!una(sec, 'asIni')) return;
      var pista = sec.querySelector('.as-resenas__grid');
      var izq = sec.querySelector('.as-resenas__flecha--izq');
      var der = sec.querySelector('.as-resenas__flecha--der');
      if (!pista) return;
      function estado() {
        if (izq) izq.disabled = pista.scrollLeft < 8;
        if (der) der.disabled = pista.scrollLeft + pista.clientWidth > pista.scrollWidth - 8;
      }
      sec.querySelectorAll('[data-as-mover]').forEach(function (b) {
        b.addEventListener('click', function () {
          var tarjeta = pista.querySelector('.as-resena');
          var paso = tarjeta ? tarjeta.offsetWidth + 16 : pista.clientWidth;
          pista.scrollBy({ left: paso * parseInt(b.dataset.asMover, 10), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      pista.addEventListener('scroll', estado, { passive: true });
      window.addEventListener('resize', estado);
      estado();
    });
  }

  // Cuenta animada de un número (pantalla del aparato y cifras)
  function contar(el, hasta, ms) {
    if (reduce) { el.textContent = hasta; return; }
    var desde = parseInt(el.textContent, 10) || 0;
    var t0 = null;
    function paso(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / ms);
      var e = 1 - Math.pow(1 - k, 3);
      el.textContent = Math.round(desde + (hasta - desde) * e);
      if (k < 1) requestAnimationFrame(paso);
    }
    requestAnimationFrame(paso);
  }

  // Modos: interruptor Aspirar / Soplar
  function initModos(root) {
    (root || document).querySelectorAll('[data-as-modos]').forEach(function (sec) {
      if (!una(sec, 'asIni')) return;
      var inter = sec.querySelector('.as-interruptor');
      var botones = sec.querySelectorAll('[data-as-modo]');
      var fotos = sec.querySelectorAll('.as-modos__visual img');
      var textos = sec.querySelectorAll('.as-modos__texto');
      var pantalla = sec.querySelector('.as-modos__pantalla b');
      var etiqueta = sec.querySelector('.as-modos__pantalla span');
      function poner(i) {
        inter.dataset.modo = i;
        botones.forEach(function (b, j) { b.classList.toggle('is-active', j === i); b.setAttribute('aria-pressed', j === i); });
        fotos.forEach(function (f, j) { f.classList.toggle('is-active', j === i); });
        textos.forEach(function (t, j) { t.hidden = j !== i; });
        if (pantalla) { pantalla.textContent = '0'; contar(pantalla, parseInt(botones[i].dataset.nivel, 10) || 88, 900); }
        if (etiqueta) etiqueta.textContent = botones[i].dataset.etiqueta || '';
      }
      botones.forEach(function (b, i) { b.addEventListener('click', function () { poner(i); }); });
      if (pantalla && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { poner(parseInt(inter.dataset.modo, 10) || 0); io.disconnect(); } });
        }, { threshold: 0.4 });
        io.observe(sec);
      }
    });
  }

  // Cifras que cuentan al aparecer
  function initCifras(root) {
    var els = (root || document).querySelectorAll('[data-as-contar]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var fin = parseInt(el.dataset.asContar, 10);
        el.textContent = '0';
        contar(el, fin, 1400);
        io.unobserve(el);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { if (una(el, 'asIni')) io.observe(el); });
  }

  // Página de producto: galería, opciones, cantidad y barra fija
  function initProducto(root) {
    (root || document).querySelectorAll('[data-as-producto]').forEach(function (sec) {
      if (!una(sec, 'asIni')) return;
      var principal = sec.querySelector('.as-prod__principal img');
      var minis = Array.prototype.slice.call(sec.querySelectorAll('.as-prod__mini'));
      var contador = sec.querySelector('[data-as-contador]');
      var actual = Math.max(0, minis.findIndex(function (m) { return m.classList.contains('is-active'); }));

      function mostrar(i) {
        if (!minis.length) return;
        actual = (i + minis.length) % minis.length;
        var m = minis[actual];
        minis.forEach(function (x) { x.classList.toggle('is-active', x === m); });
        principal.style.opacity = 0;
        setTimeout(function () {
          // la foto grande tiene srcset: si solo cambiamos src el navegador sigue enseñando la primera
          if (m.dataset.srcset) principal.srcset = m.dataset.srcset; else principal.removeAttribute("srcset");
          principal.src = m.dataset.full;
          principal.alt = m.dataset.alt || '';
          principal.style.opacity = 1;
        }, 160);
        if (contador) contador.textContent = (actual + 1) + ' / ' + minis.length;
        m.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { mostrar(i); }); });
      sec.querySelectorAll('[data-as-foto]').forEach(function (b) { b.addEventListener('click', function () { mostrar(actual + parseInt(b.dataset.asFoto, 10)); }); });

      var cantidad = sec.querySelector('input[name=quantity]');
      var packs = sec.querySelectorAll('[data-as-pack] input[name=as-pack]');
      var marcaPack = function () {
        packs.forEach(function (r) { r.checked = r.value === String(cantidad.value); });
      };
      packs.forEach(function (r) { r.addEventListener('change', function () { if (r.checked) cantidad.value = r.value; }); });
      if (cantidad) cantidad.addEventListener('input', marcaPack);
      sec.querySelectorAll('[data-as-cant]').forEach(function (b) {
        b.addEventListener('click', function () { cantidad.value = Math.max(1, (parseInt(cantidad.value, 10) || 1) + parseInt(b.dataset.asCant, 10)); marcaPack(); });
      });

      var datos = sec.querySelector('[data-as-variantes]');
      if (datos) {
        var variantes = JSON.parse(datos.textContent);
        var formato = sec.dataset.moneyFormat;
        var idInput = sec.querySelector('input[name=id]');
        var precio = sec.querySelector('[data-as-precio]');
        var antes = sec.querySelector('[data-as-precio-antes]');
        var botones = sec.querySelectorAll('[data-as-anadir]');
        var fijaPrecio = sec.querySelector('[data-as-fija-precio]');
        var actualizar = function () {
          var sel = [];
          sec.querySelectorAll('.as-prod__opcion').forEach(function (f) {
            var c = f.querySelector('input:checked');
            sel.push(c ? c.value : null);
            var etq = f.querySelector('[data-as-elegido]');
            if (etq && c) { var l = f.querySelector('label[for="' + c.id + '"]'); etq.textContent = l ? l.textContent.trim() : c.value; }
          });
          var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
          if (!v) return;
          idInput.value = v.id;
          if (precio) precio.textContent = money(v.price, formato);
          if (fijaPrecio) fijaPrecio.textContent = money(v.price, formato);
          var hay = v.compare_at_price && v.compare_at_price > v.price;
          if (antes) { antes.textContent = hay ? money(v.compare_at_price, formato) : ''; antes.hidden = !hay; }
          botones.forEach(function (b) { b.disabled = !v.available; b.querySelector('span').textContent = v.available ? sec.dataset.txtAnadir : sec.dataset.txtAgotado; });
          if (v.featured_media_id) {
            var i = minis.findIndex(function (m) { return m.dataset.mediaId == v.featured_media_id; });
            if (i > -1) mostrar(i);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        };
        sec.querySelectorAll('.as-prod__opcion input').forEach(function (i) { i.addEventListener('change', actualizar); });
      }

      var fija = sec.querySelector('.as-prod__fija');
      var compra = sec.querySelector('.as-prod__compra');
      if (fija && compra && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { fija.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(compra);
        var bf = fija.querySelector('[data-as-anadir]');
        if (bf) bf.addEventListener('click', function (ev) {
          ev.preventDefault();
          var b = compra.querySelector('[data-as-anadir]');
          if (b) b.click();
        });
      }
    });
  }

  function initTodo(root) {
    initAparece(root);
    if (!root) initCabecera();
    initHero(root);
    initResenas(root);
    initOferta(root);
    initOfertaPrecio(root);
    initModos(root);
    initCifras(root);
    initProducto(root);
  }

  // Carrito: "Añadir la 2ª" sube esa línea a 2 unidades (el descuento lo aplica Shopify).
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-as-pack-linea]');
    if (!b) return;
    b.disabled = true;
    fetch((window.routes && window.routes.cart_change_url ? window.routes.cart_change_url : '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(b.dataset.asPackLinea, 10), quantity: 2 })
    }).then(function () { window.location.reload(); }, function () { b.disabled = false; });
  });

  document.addEventListener('DOMContentLoaded', function () { initTodo(); });
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();

/* Ficha: opiniones cortas que van rotando y fechas de entrega calculadas (días laborables, sin sábados ni domingos) */
(function () {
  document.querySelectorAll('[data-as-mini-res]').forEach(function (c) {
    var f = c.querySelectorAll('figure'); if (f.length < 2) return;
    var i = 0;
    setInterval(function () { f[i].classList.remove('is-active'); i = (i + 1) % f.length; f[i].classList.add('is-active'); }, 4500);
  });
  var linea = document.querySelector('[data-as-linea]'); if (!linea) return;
  var lab = function (d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d; };
  var rango = function (t) { var p = String(t || '').split('-').map(function (x) { return parseInt(x, 10) || 0; }); return [p[0], p[1] || p[0]]; };
  var loc = document.documentElement.lang || 'es';
  var fmt = function (d) { return d.toLocaleDateString(loc, { day: 'numeric', month: 'short' }); };
  var hoy = new Date(), prep = rango(linea.dataset.prep), ent = rango(linea.dataset.entrega);
  var f = linea.querySelectorAll('[data-as-fecha]');
  f[0].textContent = fmt(hoy);
  f[1].textContent = fmt(lab(hoy, prep[0])) + ' - ' + fmt(lab(hoy, prep[1]));
  f[2].textContent = fmt(lab(hoy, ent[0])) + ' - ' + fmt(lab(hoy, ent[1]));
})();
